const styles = (theme) => ({
  span: {
    cursor: "none !important",
    flexBasis: "30%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      flexBasis: "100%",
      width: "100%",
      marginBottom: "20px",
    },
  },
  input: {
    cursor: "none !important",
    backgroundColor: "transparent",
    border: "1px solid black",
    padding: "14px",
    width: "100%",
    color: "black",
    textAlign: "left",
    "&:focus": {
      backgroundColor: "transparent !important",
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
      width: "100%",
      textAlign: "left",
    },
  },
  menuItem: {
    backgroundColor: "#808070 !important",
    color: "black",
    fontFamily: "Aktiv Grotesk",
    padding: "1rem",
    fontWeight: 400,
  },
  menuSelected: {
    backgroundColor: "#5B5B51 !important",
  },
  icon: {
    marginLeft: "-32px",
    cursor: "pointer",
    pointerEvents: "none",
    height: "24px",
    width: "24px",
    transform: "scale(0.85)",
    transformOrigin: "center",
  },
  label: {
    margin: "0",
    fontSize: "12px",
    color: "black",
    alignSelf: "flex-start",
    fontFamily: "Aktiv Grotesk",
    marginBottom: ".5rem",
    fontWeight: "400",
  },
});

export default styles;
